(function(){
  var lastPresenter;

  PegasusTemplate.ModalController = Ember.ObjectController.extend({
    presenter: function(_,value){
      if ( typeof(value) !== 'undefined' ) {
        if ( lastPresenter ) {
          lastPresenter.willClose();
        }
        lastPresenter = value;
        return lastPresenter;
      }
      return null;
    }.property(),
    deleteBlock: function(){
      this.get('content.parentView').removeChild(this.get('content'));
      this.get('content').destroy();
      PegasusTemplate.stateMachine.transitionTo('idling');
    },
    didChangePresenter: function(){
      if ( this.get('presenter') ) {
        $('<div class="editing-overlay"/>').appendTo('body');
        return;
      }

      $('.editing-overlay').remove();
    }.observes('presenter')
  });
})();
